import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import requester from '../../lib/requester'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import moment from 'moment'
import _ from 'lodash'
import ReactExport from "react-export-excel-hot-fix"
import ReactDatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import "react-datepicker/dist/react-datepicker-cssmodules.css"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

class Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1),
            endDate: new Date(),
            dataTable: [],
            baseTable: [],
            search: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }

    componentDidMount = () => {
        this.populateList();
    }

    populateList = () => {
        let url = '/api/traces/v1/assign/summary'
        let branchGroup = this.state.user.branch.map((item, index) => {
            return item.org_id
        })
        let param = {
            // org_id: this.state.user.org_id,
            branch: branchGroup
        }
        param.startDate = moment(this.state.startDate).format('YYYY-MM-DD');
        param.endDate = moment(this.state.endDate).format('YYYY-MM-DD');
        this.setState({ loading: true })
        requester.postTraces(url, param, {
            success: function(response) {
                let { data } = response.data
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data})
            }.bind(this),
            error: function(e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    renderTable = () => {
        const data = {
            columns: [
                {
                    Header: 'TRACES NO',
                    accessor: 'skp_number'
                    ,filterable: true
                },
                {
                    Header: 'PROGRAM NO',
                    accessor: 'program_number'
                    ,filterable: true
                },
                {
                    Header: 'REF NO',
                    accessor: 'ref_number'
                    ,filterable: true
                },
                {
                    Header: 'PROGRAM TYPE',
                    accessor: 'program_name'
                    ,filterable: true
                },
                {
                    Header: 'DESCRIPTION',
                    accessor: 'description'
                    ,filterable: true
                },
                {
                    Header: 'PRINCIPAL',
                    accessor: 'org_name'
                    ,filterable: true
                },
                // {
                //     Header: 'START DATE',
                //     accessor: 'start_date',
				// 	Cell: row => (
				// 		<span>
				// 			<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
				// 			</span>
				// 		</span>
				// 	)
                // },
                // {
                //     Header: 'END DATE',
                //     accessor: 'end_date',
				// 	Cell: row => (
				// 		<span>
				// 			<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
				// 			</span>
				// 		</span>
				// 	)
                // },

                // {
                //     Header: 'BUDGET TYPE',
                //     accessor: 'budget_type'
                // },
                {
                    Header: 'SUBMITTED DATE',
                    accessor: 'creation_date',
                    Cell: row => (
						<span>
							<span>{row.value !== null ? moment(row.value).format("DD-MMM-YYYY") : ""}
							</span>
						</span>
					)
                },
                {
                    Header: 'BUDGET',
                    accessor: 'budget',
                    className: 'text-right',
                    // filterable: true,
                    Cell: (row) => {
                        let value = parseFloat(row.value)
                        return (<span>{value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>)
                    }
                   
                    ,filterable: true
                },
                {
                    Header: 'CUSTOMER',
                    accessor: 'customer',
                    Cell: row => (
                    <span>{ row.value.toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</span>
                    )
                    ,filterable: true
                },
                {
                    Header: 'STATUS',
                    accessor: 'status',
                    Cell: row => (
                        <span>{ row.value == 'A'? 'ACTIVE':'INACTIVE'}</span>
                        
                    )
                    ,filterable: true
                },
                {
                    Header: '',
                    accessor: 'program_customer_id',
					Cell: row => (
						<span>
                            <button className="btn btn-success btn-sm" onClick={ () => { this.goDetail(row) } }>View <i className="fas fa-eye" /></button>
						</span>
					)
                }
            ],
            rows: this.state.dataTable

        }
        return (<ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={((filter, row, column) => {
                let columnes = ""
                switch (filter.id) {
                    case "START_DATE_PROGRAM":
                        columnes = row._original.formatted_START_DATE_PROGRAM
                        break;
                    default:
                        columnes = row[filter.id]
                }

                return (columnes ? columnes.toLowerCase().includes(filter.value.toLowerCase()) : '')
            })}
        />)
    }

    exportToExcel = () => {
        const dataSet2 = this.state.dataTable
        let filename = 'assign-summary-' + moment(new Date()).format('DDMMYYYYHHmmss')
        
        return (
          <ExcelFile filename={filename} fileExtension="xls" element={(<button className="btn btn-success"><i className="fas fa-file-excel" />Export to Excel</button>)}>
            <ExcelSheet data={dataSet2} name="Leaves">
              <ExcelColumn label="Ref No" value="ref_number" />
              <ExcelColumn label="Program Type" value="program_name" />
              <ExcelColumn label="Description" value="description" />
              <ExcelColumn label="Customer" value="customer" />
              <ExcelColumn label="Principal" value="org_name" />
              <ExcelColumn label="Start Date" value="formatted_start_date" />
              <ExcelColumn label="End Date" value="formatted_end_date" />
              {/* <ExcelColumn label="Budget Type" value="budget_type" /> */}
              <ExcelColumn label="submitted Date" value="creation_date" />
              <ExcelColumn label="Member" value="member_name" />
              <ExcelColumn label="Status" value="status" />
            </ExcelSheet>
          </ExcelFile>
        );
    }

    goDetail = (rows) => {
        let { row } = rows
        this.props.history.push('/admin/assign/summary/' + row.program_customer_id)
    }

    handleSearch = (e) => {
        let value = e.target.value.toLowerCase()
        let container = []
        _.find(this.state.baseTable, function(o) {
            let desc = o.description.toLowerCase()
            if(desc.indexOf(value) >= 0){
                container.push(o);
            }
        })
        container.forEach((item, index) => {
            item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
            item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
            return item
        })
        this.setState({ dataTable: container, search: value })
    }

    handleChangeStatus = (e) => {
        let value = e.target.value
        let url = '/api/v1/assign/assignsummary?status=' + value
        let param = {
            org_id: this.state.user.org_id
        }
        this.setState({ loading: true, search: "" })
        requester.postTraces(url, param, {
            success: function(response) {
                let { data } = response.data
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data })
            }.bind(this),
            error: function(e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    badgeClass = (status) => {
        let className = ''
        if (status === 'P') {
            className = 'badge badge-info'
        } else if (status === 'A') {
            className = 'badge badge-success'
        } else if (status === 'R') {
            className = 'badge badge-danger'
        } else if (status === 'S') {
            className = 'badge badge-secondary'
        }
        console.log(className)
        return className
    }

    mappingStatus = (status) => {
        let mappingStatus = ''
        if (status === 'P') {
            mappingStatus = 'PROPOSE'
        } else if (status === 'A') {
            mappingStatus = 'APPROVED'
        } else if (status === 'R') {
            mappingStatus = 'REJECT'
        }else if (status === 'S') {
            mappingStatus = 'ASSIGN'
        }
        console.log(mappingStatus)
        return mappingStatus
    }

    filter = () => {
        this.populateList();
    }

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div>
                                                <p className='m-0'><strong>Start Date</strong></p>
                                                <ReactDatePicker
                                                    className='date-border'
                                                    dateFormat={'dd-MMM-yyyy'}
                                                    selected={this.state.startDate}
                                                    onChange={(date) => this.setState({startDate: date})}
                                                    selectsStart
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                />
                                            </div>
                                            <div className='ml-2'>
                                                <p className='m-0'><strong>End Date</strong></p>
                                                <ReactDatePicker
                                                    className='date-border'
                                                    dateFormat={'dd-MMM-yyyy'}
                                                    selected={this.state.endDate}
                                                    onChange={(date) => this.setState({endDate: date})}
                                                    selectsEnd
                                                    startDate={this.state.startDate}
                                                    endDate={this.state.endDate}
                                                    minDate={this.state.startDate}
                                                />
                                            </div>
                                            <div className='ml-2 align-self-end'>
                                                <button onClick={this.filter} className="btn btn-success btn-sm">Filter</button>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 float-left">
                                                <div className="row">
                                                {/* { this.exportToExcel() } */}
                                                    {/* <div className="col-lg-6">
                                                        <select name="" className="form-control" onChange={ this.handleChangeStatus.bind(this) }>
                                                            <option value="S">ASSIGN</option>
                                                        </select>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="row">
                                                    {/* <div className="col-lg-6">
                                                        <input type="text" className="form-control" onChange={ this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                    </div> */}
                                                    <div className="col-lg-3">
                                                        {/* <button className="btn btn-success"><i className="fas fa-file-excel" /></button> */}
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                { this.renderTable() }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Loader fullPage loading={this.state.loading} />
                </section>
            </div>
        )
    }
}

export default Summary